import type { FC, SVGProps } from 'react';
import claudeDesktopPng from './claude_desktop.png';

export const ClaudeDesktopIcon: FC<SVGProps<SVGSVGElement>> = ({
  className,
  style,
}) => (
  <img
    src={claudeDesktopPng}
    alt="Claude Desktop"
    className={className}
    style={style}
  />
);
